import { 
  reverb_pricing_PriceRecommendation, 
  reverb_pricing_Money, 
} from '@reverbdotcom/commons/src/gql/graphql';

interface IPriceRange {
  priceLow: reverb_pricing_Money;
  priceHigh: reverb_pricing_Money;
}

// Assumes that the price for the best condition is the first estimate in the array,
// based on the order of price guide conditions in the condition helper.
// A bit brittle, but a follow up could involve a ranking helper for conditions
function estimateForBestCondition(estimates: reverb_pricing_PriceRecommendation[]) {
  return estimates[0] || {};
}

// Assumes that the price for the worst condition is the last estimate in the array,
// based on the order of price guide conditions in the condition helper.
// A bit brittle, but a follow up could involve a ranking helper for conditions
function estimateForWorstCondition(estimates: reverb_pricing_PriceRecommendation[]) {
  return estimates[estimates.length - 1] || {};
}

export function calculatedPriceMiddle({ 
  priceLow = {}, 
  priceHigh = {}, 
}: IPriceRange) {
  if (!priceLow.amountCents || !priceHigh.amountCents) return {};
  if (priceLow.currency != priceHigh.currency) return {};

  const middlePriceCents = (priceLow.amountCents + priceHigh.amountCents) / 2;

  return {
    amountCents: middlePriceCents,
    currency: priceLow.currency,
  };
}

// Assumes estimate is for the same CSP or CP across multiple conditions
export function determineEstimateFromMultipleConditions(estimates: reverb_pricing_PriceRecommendation[]) {
  
  const {
    priceHigh = {},
    priceHighThirtyDaysAgo = {},
  } = estimateForBestCondition(estimates);

  const {
    priceLow = {},
    priceLowThirtyDaysAgo = {},
  } = estimateForWorstCondition(estimates);

  const priceMiddle = calculatedPriceMiddle({
    priceHigh,
    priceLow,
  });

  const priceMiddleThirtyDaysAgo = calculatedPriceMiddle({
    priceHigh: priceHighThirtyDaysAgo,
    priceLow: priceLowThirtyDaysAgo,
  });

  return {
    priceLow,
    priceMiddle,
    priceHigh,
    priceMiddleThirtyDaysAgo,
  };
}
